import { render, staticRenderFns } from "./RegisterAttendance.vue?vue&type=template&id=509c4b09&scoped=true"
import script from "./RegisterAttendance.vue?vue&type=script&lang=js"
export * from "./RegisterAttendance.vue?vue&type=script&lang=js"
import style0 from "./RegisterAttendance.vue?vue&type=style&index=0&id=509c4b09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c4b09",
  null
  
)

export default component.exports